import styled from 'styled-components';
import { getStatusCARColor, getStatusMatriculaColor, getScoreColor } from '../../constants/functions';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
  justify-content: stretch;
  align-items: stretch;
  width: 100%;
  box-sizing: border-box;

  @media screen and (min-width: 1920px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 1.25rem;
  }

  @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    justify-items: center;
    gap: 12px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;
  height: 40vh;
  min-height: 320px;
  background: var(--surface-1);
  border-radius: 8px;
  box-shadow: var(--shadow-sm);
  padding: 16px;
  margin: 0;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid var(--border-strong);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  box-sizing: border-box;

  @media screen and (min-width: 1920px) {
    height: clamp(380px, 42vh, 520px);
    min-height: 380px;
    padding: 20px;
  }

  @media screen and (max-width: 768px) {
    width: min(100%, 300px);
    height: auto;
    min-height: 220px;
    margin: 0 auto;
    overflow: hidden;
  }

  &:hover {
    transform: translateY(-6px);
    border-color: var(--accent);
    background: var(--surface-1);
    box-shadow: var(--shadow-md);
  }

  &:active {
    transform: translateY(-2px);
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  max-width: 200px;
  height: 150px;
  margin: 0 auto;
  flex: 1 1 auto;
  min-height: 120px;
  max-height: 180px;
  overflow: hidden;
  border-radius: 4px;

  @media screen and (min-width: 1920px) {
    max-width: none;
    height: auto;
    min-height: 180px;
    max-height: 260px;
    aspect-ratio: 16 / 10;
  }

  @media screen and (max-width: 768px) {
    width: 70px;
    height: 60px;
    min-height: 60px;
    max-height: 60px;
    margin: 0;
    flex: 0 0 auto;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
  display: block;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  flex: 0 0 auto;
  width: 100%;
  min-width: 0;
  margin-top: 12px;
  overflow: visible;

  @media screen and (max-width: 768px) {
    height: auto;
    min-height: 0;
    flex: 1 1 auto;
  }

  @media screen and (min-width: 1920px) {
    margin-top: 16px;
    gap: 2px;
  }
`;


export const Title = styled.h2`
  font-size: 1rem;
  font-weight: bold;
  color: ${props => getScoreColor(props.score)};
  font-family: "Lucida Sans Unicode", "Lucida Grande", sans-serif;
  align-self: stretch;
  width: 100%;
  margin: 8px 0;
  color: var(--text-primary);
  text-align: center;
  line-height: 1.3;
  word-break: break-word;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;

  @media screen and (min-width: 1920px) {
    font-size: 1.2rem;
    line-height: 1.35;
    margin: 4px 0 10px;
    -webkit-line-clamp: 4;
  }
`;

export const Info = styled.p`
  font-size: 0.80rem;
  margin: 2px 0;
  padding: 0;
  width: 100%;
  font-family: "Times New Roman", Times, serif;
  font-style: italic;
  color: var(--text-primary);
  line-height: 1.35;
  word-break: break-word;

  @media screen and (min-width: 1920px) {
    font-size: 0.9rem;
    margin: 3px 0;
  }
`;

export const ScoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: var(--surface-1);
  border-radius: 50%;
  box-shadow: var(--shadow-sm);
  font-size: 24px;
  font-weight: bold;
  position: absolute;
  top: -10px;
  right: -10px;
  color: ${props => getScoreColor(props.score)};

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MobileScoreContainer = styled.div`
  display: none;
  color: ${props => getScoreColor(props.score)};
  
  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    background-color: var(--surface-1);
    border-radius: 50%;
    box-shadow: var(--shadow-sm);
    font-size: 12px;
    font-weight: 700;
    position: absolute;
    top: -12px;
    right: -12px;
    z-index: 10;
  }
`;

export const StatusCAR = styled.span`
  color: var(--text-primary);
`;

export const StatusMatricula = styled.span`
  color: var(--text-primary);
`;